import drEasyApi from "./Customapi";

export const checkUserStatus = async (slug) => {
  const token =
    localStorage.getItem(`userTkn-${slug}`) ||sessionStorage.getItem(`userTkn-${slug}`);


  if (!token || !slug) return null;

  const res = await drEasyApi.get(`/api/Book/CheckUser`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};
